import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import IdaraImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Idara Suit -  Data School Support Person.png";
import AbolanleImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/abolanle1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/eniola.webp";
import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/ikyo.webp";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/data.webp";
import PortfolioUserAvatar from "../../../../../assets/images/png/courses/portfolio/samuel.jpeg";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import DataSciencePreview from "../../../../../assets/images/jpeg/dataSciencePreview.jpg";

import bankoleoluwatosin from "../../../../../assets/images/png/courses/testimonies/bankoleoluwatosin.png";
import adetolaolamide from "../../../../../assets/images/png/courses/testimonies/adetolaolamide.png";
import biliyabulus from "../../../../../assets/images/png/courses/testimonies/biliyabulus.png";
import chinasa from "../../../../../assets/images/png/courses/testimonies/chinasa.png";
import enioladaniel from "../../../../../assets/images/png/courses/testimonies/enioladaniel.png";
import gideoneunane from "../../../../../assets/images/png/courses/testimonies/gideoneunane.png";
import idara from "../../../../../assets/images/png/courses/testimonies/idara.png";
import israelbabajide from "../../../../../assets/images/png/courses/testimonies/israelbabajide.png";
import jamesemmanuel from "../../../../../assets/images/png/courses/testimonies/jamesemmanuel.png";
import janetomowumi from "../../../../../assets/images/png/courses/testimonies/janetomowumi.png";
import maybrown from "../../../../../assets/images/png/courses/testimonies/maybrown.png";
import nkirukaetoniru from "../../../../../assets/images/png/courses/testimonies/nkirukaetoniru.png";
import olusojiadejuwon from "../../../../../assets/images/png/courses/testimonies/olusojiadejuwon.png";
import oyedamolaoyeleye from "../../../../../assets/images/png/courses/testimonies/oyedamolaoyeleye.png";
import orewoleogungbeje from "../../../../../assets/images/png/courses/testimonies/orewoleogungbeje.png";

export const dataScienceFellowshipAfrica = {
  id: 1,
  tag: "FOR DATA ENTHUSIASTS",
  title: "Data Science Bootcamp",
  seoTitle: "Data Science Bootcamp | Utiva Nigeria",
  description: `
  Designed for people exploring the tech industry as data scientists — future data analysts,
  business intelligence analysts, SQL analysts, Python analysts, machine learning
  practitioners, and insight professionals solving real-world problems with data.
    `,
  heroSubtitle:
    "Learn data science — Excel, SQL, Power BI, Python, analytics, and machine learning — through live weekend classes and real-world projects.",
  metatags: `Turn data into decisions businesses can act on. Master Excel, SQL, Power BI, Python, and machine learning with Utiva's Data Science Bootcamp.`,
  duration: "6 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1zo0mYr0l0MU5NaxfvLLwXtdC7o6HrT6Z/view?usp=sharing",

  courseFormUrl: "courses/data-science-bootcamp/fill-form",

  jobTitle: "Data Scientist",

  kickoffDate: "July 18, 2026",
  kickoffTime: "Weekends only",

  testimonial: {
    image: Instructor1,
    name: "Doluwamu Ayotunde",
    role: "Senior Data Scientist",
    testimony: `
    This course is everything a data scientist needs — every lesson has actionable
    learnings that spark new ideas.`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Turn data into decisions businesses can act on.`,
    desc: (
      <>
        This program is vetted, tested, and approved by senior-level data
        scientists and analytics professionals from companies like Salesforce,
        Spotify, Google, Meta, Flutterwave, and Paystack, so you can be sure
        you&rsquo;re getting the real deal.
        <br />
        <br />
        The curriculum combines data analysis, business intelligence, Python,
        and machine learning, teaming up practical, project-based teaching with
        data science powerhouses throughout the course.
      </>
    ),
  },

  keyOutcomesHeading: "Prepare. Analyse. Visualise. Predict.",

  keyOutcomes: [
    {
      label: "Prepare",
      desc:
        "Clean, organise, and structure data in Excel, SQL, Power BI, and Python.",
    },
    {
      label: "Analyse",
      desc:
        "Use formulas, queries, statistical methods, and Python libraries to uncover patterns and answer business questions.",
    },
    {
      label: "Visualise",
      desc:
        "Build charts, dashboards, and clear data stories that communicate insights to stakeholders.",
    },
    {
      label: "Predict",
      desc:
        "Apply feature engineering and machine learning models to make predictions and support better decisions.",
    },
  ],

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Introduction to Spreadsheets",
      unitTag: "Excel",
      unitDescription: `
      Build foundational confidence with spreadsheets and understand how Excel supports data
      analysis.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to spreadsheets",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Understanding worksheets, rows, columns, and cells",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Entering and organising data",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Excel Functions and Formatting",
      unitTag: "Excel",
      unitDescription: `
      Learn how Excel functions are structured and apply simple formatting to make data clear
      and usable.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Structure of an Excel function",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Applying simple formulas",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Applying simple formats",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Logical Functions, Lookups and Charts",
      unitTag: "Excel",
      unitDescription: `
      Use logical and lookup functions to retrieve information and create basic
      visualisations.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "The IF command",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "LOOKUP functions",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "INDEX and MATCH",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Basic Excel charts A",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Charts, What-If Analysis and Cleaning",
      unitTag: "Excel",
      unitDescription: `
      Clean and explore spreadsheet data using charts and scenario-based analysis.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Basic Excel charts B",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "What-If Analysis",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Data cleansing",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Excel Capstone and LinkedIn Optimisation",
      unitTag: "Project",
      unitDescription: `
      Apply your Excel skills in a practical project and strengthen your professional
      visibility.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Excel capstone project",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "LinkedIn optimisation session",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Project presentation and feedback",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Databases and PostgreSQL Fundamentals",
      unitTag: "Databases",
      unitDescription: `
      Understand how databases store information and get started with PostgreSQL.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to PostgreSQL",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Introduction to databases",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Relational database concepts",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Introduction to SQL",
      unitTag: "SQL",
      unitDescription: `
      Learn the foundations of SQL and write your first database queries.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to SQL",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "SQL syntax and statements",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Selecting data from tables",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Querying and Combining Data",
      unitTag: "SQL",
      unitDescription: `
      Retrieve, organise, and combine data from multiple tables using practical SQL
      techniques.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Querying, sorting, filtering, and grouping data",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Subqueries",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "SQL joins",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "SQL Data Cleaning and Capstone",
      unitTag: "SQL",
      unitDescription: `
      Prepare SQL data for analysis, work with dates, and complete a practical database
      project.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Data cleaning",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Date functions",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "SQL wrap-up",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "SQL capstone project",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "Power BI and Data Preparation",
      unitTag: "Power BI",
      unitDescription: `
      Get started with Power BI and transform raw data into analysis-ready datasets.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Power BI",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Data preparation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Loading and transforming data",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 11,
      unitTitle: "Data Modelling and Visualisation",
      unitTag: "Power BI",
      unitDescription: `
        Build reliable data models and create visual reports that communicate patterns
        clearly.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Data modelling",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Data relationships",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Data visualisation",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 12,
      unitTitle: "Interactive Dashboards and Capstone",
      unitTag: "Power BI",
      unitDescription: `
      Design interactive dashboards that turn analysis into clear business stories.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Interactive dashboards for storytelling",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Dashboard design and interactivity",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Power BI capstone project",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 13,
      unitTitle: "Python and Anaconda Fundamentals",
      unitTag: "Python",
      unitDescription: `
     Set up a Python data science environment and learn the core data types used in
     analysis.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Anaconda",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Python data types",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Working in notebooks",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 14,
      unitTitle: "Python Functions and Data Processing",
      unitTag: "Python",
      unitDescription: `
      Write reusable Python logic and process datasets using conditions, methods, and
      functions.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Conditions in Python",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Methods and functions",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Data processing",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 15,
      unitTitle: "Data Analysis with NumPy and Pandas",
      unitTag: "Python",
      unitDescription: `
      Analyse and manipulate data efficiently with NumPy and Pandas.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Data analysis with NumPy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Data analysis with Pandas",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Working with data",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 16,
      unitTitle: "Feature Engineering and ML Models",
      unitTag: "Machine Learning",
      unitDescription: `
     Prepare data for machine learning and build foundational predictive models.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Feature engineering",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Feature scaling and feature selection",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Logistic regression",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Support vector machines",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 17,
      unitTitle: "Decision Trees and Prediction Project",
      unitTag: "Machine Learning",
      unitDescription: `
      Build and evaluate a decision-tree model through a practical prediction project.`,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Decision trees",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Wine quality prediction",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Final data science project",
          featureDescription: ``,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
      coachQuote:
        "This course is everything a data scientist needs — every lesson has actionable learnings that spark new ideas.",
    },
    {
      coachId: 2,
      coachImage: AbolanleImage,
      coachName: "Abolanle",
      coachRole: "Data Analytics Practice Lead",
    },
    {
      coachId: 3,
      coachImage: IdaraImage,
      coachName: "Idara",
      coachRole: "Data School Support",
    },
    {
      coachId: 4,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "6 Months, Hands-On",
      modelDescription:
        "An experiential learning and hands-on training journey, not a lecture series.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Real-Life Problems",
      modelDescription:
        "Every lesson is built around a real-world data problem, not an abstract exercise.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Case-Driven",
      modelDescription:
        "Apply what you learn directly to a practical data problem across the cohort.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "50 / 50 Delivery",
      modelDescription:
        "Half your time in self-paced material, half in live weekend classes.",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/eniola-orireyemi-872357117/",
      image: Testimony2,
      firstname: "Eniola",
      lastname: "Orireyemi",
      company: "Data Scientist, truQ",
      testimony: `
      My training at Utiva was really great. I took the training in 2020, and to a very
      large extent, it's still one of the most solid training experiences I've had. I still
      recommend Utiva till date.
      `,
    },
    {
      id: 2,
      linkedIn: "https://www.linkedin.com/in/terhileikyo/",
      image: Testimony1,
      firstname: "Terhile",
      lastname: "Ikyo",
      company: "Senior Project Manager, Helium Health",
      testimony: `
      This course is everything a data scientist needs, and it explores the unique role
      of a data scientist in a way that has simply not been done before. Every lesson
      sparks new ideas.
      `,
    },
    {
      id: 3,
      linkedIn: "",
      image: bankoleoluwatosin,
      source: "google",
      firstname: "Bankole",
      lastname: "Oluwatosin",
      company: "",
      testimony: `
      After-Class Feedback for Okolie Rachael – Utiva Data Analytics Instructor.
      Last Sunday's session marked our second live class, and it was incredibly
      insightful—thanks to Ms. Rachael's clear, patient, and engaging teaching style.
      She took the time to ensure every student understood the concepts, never
      hesitating to revisit challenging points with calm and grace. Her depth of
      knowledge, coupled with her approachable demeanour, made the learning
      experience smooth and empowering. I'm truly grateful for the way she carries
      the entire class along, making sure no one is left behind. Thank you, Ms.
      Rachael
      `,
    },
    {
      id: 4,
      linkedIn: "",
      image: gideoneunane,
      source: "google",
      firstname: "Gideon",
      lastname: "Unane",
      company: "",
      testimony: `
      Transitioning from a career in media production and video editing into Data
      Science seemed daunting, but Utiva has made the journey incredibly smooth.
      The classes are practical, highly interactive, and broken down in a way that
      is very easy to understand. The instructors are fantastic; they are always
      approachable and genuinely committed to ensuring you have a solid
      foundational understanding before moving forward. Highly recommend their
      program to anyone looking to pivot into tech
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: jamesemmanuel,
      source: "google",
      firstname: "James",
      lastname: "Emmanuel",
      company: "",
      testimony: `
      I'm currently doing Data Science with Utiva, and it has been an amazing
      experience so far. The program is practical, well-structured, and
      beginner-friendly. The instructors explain complex concepts clearly and
      focus on real-world projects. I'm truly enjoying the journey and would
      recommend Utiva to anyone looking to build strong data skills.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: adetolaolamide,
      source: "google",
      firstname: "Adetola",
      lastname: "Olamide",
      company: "",
      testimony: `
      It's being a wonderful and impactful experience with Utiva Academy so far.
      This program has not teach me the technical part only but some other soft
      and interpersonal skills. Although, lately I haven't being able to join
      live classes due to my school workload but my trainer has actually being
      exceptional. With the time I was able to join her live classes, I could
      feel how energetic her class is, very eager to answer any student
      question, very open to learning and also her explanation is new concept
      is excellent. the name of my trainer is Coach Rachel, and I am studying
      Data Science.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: null,
      source: "google",
      firstname: "Tawakalt",
      lastname: "Owolarafe",
      company: "",
      testimony: `
      Enrolling in the data science course has been one of the best decisions
      I've made recently. The teacher, Rachael is really good and always ready
      to help.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: null,
      source: "google",
      firstname: "Blessing",
      lastname: "",
      company: "",
      testimony: `
      I really enjoyed Coach Ayo's SQL sessions under Utiva's Data Science
      program. He explained complex concepts in a clear and practical way,
      always taking the time to ensure everyone understood before moving on.
      His teaching style made SQL not just easier, but genuinely interesting to
      learn. Thank you, Coach Ayo, for your patience and support throughout the
      course.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: orewoleogungbeje,
      source: "google",
      firstname: "Orowole",
      lastname: "Ogunbeje",
      company: "",
      testimony: `
      Showing up on social media or getting involved in talent show hasn't
      really been a part of me, I didn't even know where to begin. However, the
      meeting held with Coach Ayo on how to leverage on Github to build our
      portfolio and show case what we have mastered so far is everything I
      needed to put myself out there. Thank you UTIVA for not just teaching,
      but working us through every part of transitioning into Tech (Data
      Science) while holding us by the hand. Thank you Coach Ayo! Thank you
      UTIVA!!
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: null,
      source: "google",
      firstname: "Ofelo",
      lastname: "Maria",
      company: "",
      testimony: `
      I'm excited to be part of the class. i appreciate your time and effort..
      Again i would say that... Mr. Ayo is an outstanding educator who truly
      knows how to bring complex data science concepts to life. Their teaching
      style is engaging, and they're always willing to go the extra mile to
      ensure students understand the material. Highly recommended.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: maybrown,
      source: "google",
      firstname: "May",
      lastname: "Brown",
      company: "",
      testimony: `
      Mr Ayo (data science trainer). I've had the privilege of training with
      Mr. Ayo, and I can confidently say he is an outstanding trainer. His
      dedication, patience, and deep knowledge truly set him apart. He has a
      unique way of breaking down complex concepts into simple, practical steps
      that make learning both enjoyable and effective.
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: biliyabulus,
      source: "google",
      firstname: "Biliya",
      lastname: "Bulus",
      company: "",
      testimony: `
      It was a wonderful experience. I live every bit of it. Thank you to Mr.
      AYO my Data Science tutor. He is such an amazing person and also a
      teacher. I got to learn a lot from him
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: enioladaniel,
      source: "google",
      firstname: "Eniola",
      lastname: "Daniel",
      company: "",
      testimony: `
      Ayo, Data Science. He has been very helpful in the course of my learning
      journey... He is a skilled trainer with in-depth knowledge of Data
      Science. #UTIVA
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: olusojiadejuwon,
      source: "google",
      firstname: "Olusoji",
      lastname: "Adejuwon",
      company: "",
      testimony: `
      The Utiva Data Science program stands out due to its meticulously
      structured design and pedagogical approach, which collectively foster
      effective learning and comprehensive skill acquisition. Also, Mr. Ayo
      plays a crucial role in making complex technical subjects accessible and
      building practical proficiency, even for me, from a different academic
      background. The program's success in transforming me from a
      "non-programming background" into a confident and competent user of core
      data science tools like SQL, Power BI, and Python is a testament to Mr.
      Ayo's pedagogical effectiveness.
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: null,
      source: "google",
      firstname: "Eme",
      lastname: "Etuk",
      company: "",
      testimony: `
      My name is Eme Ukut, and I am currently undertaking the Data Science
      course at Utiva, which is taught by Mr Ayobami Oje, and I must say that
      it has been an exceptional learning experience. The course is
      well-structured, and Mr Ayobami's teaching style has helped make complex
      concepts easy to understand. I highly recommend this course to anyone
      interested in data science. Mr Ayobami Oje's expertise and experience
      have made the learning experience enjoyable and informative. I'm
      confident and hopeful that the skills I am acquiring will benefit my
      future endeavours.
      `,
    },
    {
      id: 16,
      linkedIn: "",
      image: nkirukaetoniru,
      source: "google",
      firstname: "Nkiruka",
      lastname: "Etoniru",
      company: "",
      testimony: `
      I am currently enrolled in the Data Science program at Utiva, and I must
      say, this is one of the best decisions of my life! The experience has
      been nothing short of transformative and the curriculum is
      well-structured, hands-on, and tailored to equip students with
      real-world skills in data analysis. A special shoutout to Mr. Ayo, our
      instructor, whose teaching style is both engaging and clear. He breaks
      down complex concepts into digestible bits and always takes time to
      ensure no one is left behind. His patience, depth of knowledge, and
      practical approach to learning have made this journey incredibly
      rewarding. Highly recommend Utiva to anyone serious about building a
      career in tech!
      `,
    },
    {
      id: 17,
      linkedIn: "",
      image: chinasa,
      source: "google",
      firstname: "Chinasa",
      lastname: "",
      company: "",
      testimony: `
      I attended Utiva's Zoom meeting and it was very awesome. I'm looking
      forward to enroll for theri fellowship and learn all about Data Science.
      `,
    },
    {
      id: 18,
      linkedIn: "",
      image: null,
      source: "google",
      firstname: "Stephen",
      lastname: "Guobadia",
      company: "",
      testimony: `
      Great place to learn Data Science as they have amazing Instructors that
      break down even the most complex ideologies into simple bits.
      `,
    },
    {
      id: 19,
      linkedIn: "",
      image: janetomowumi,
      source: "google",
      firstname: "Janet",
      lastname: "Omowunmi",
      company: "",
      testimony: `
      Learning with Tutor Ayo during the Data Science program was a great
      experience. He made complex topics easy to understand and always took
      time to explain until everyone was carried along. His sessions were
      engaging, practical, and very supportive, which made learning fun and
      impactful. Big thanks to him for his patience and dedication — I
      definitely feel more confident in applying data science skills now.
      `,
    },
    {
      id: 20,
      linkedIn: "",
      image: oyedamolaoyeleye,
      source: "google",
      firstname: "Oyedamola",
      lastname: "Oyeyele",
      company: "",
      testimony: `
      I love the fact that the data science workshop was very detailed. Thanks
      to Ayo for making it so easy
      `,
    },
    {
      id: 21,
      linkedIn: "",
      image: israelbabajide,
      source: "google",
      firstname: "Israel",
      lastname: "Babajide",
      company: "",
      testimony: `
      Utiva is an amazing platform with intelligent faculty focused on
      capacity building in tech areas such as Data Science & Product
      management and design.
      `,
    },
    {
      id: 22,
      linkedIn: "",
      image: idara,
      source: "google",
      firstname: "Idara",
      lastname: "",
      company: "",
      testimony: `
      One thing I've enjoyed about learning at Utiva is how the trainers
      explain things. Coach Rachel, especially, makes the classes engaging and
      clear. It's really a good place to build tech skills.
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real Business Cases",
    description: `
    Work on a real-world data case developed with industry mentors — applying data
    preparation, analysis, visualisation, SQL, Python, and machine learning to solve
    a business problem.
      `,

    deliverables: [
      "Weekly, mentor-reviewed milestones",
      "A finished analysis, dashboard, and predictive model",
      "A portfolio-ready data science case study",
    ],

    name: "Samuel Falowo",
    image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "A Utiva Certificate, Made to Be Shared",
    description: `
    Upon completing the course, you'll receive an industry-recognised, professional
    certificate — formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://www.youtube.com/embed/7yscoTvdjEo",
  // videoTestimonial: "https://www.youtube.com/embed/uvsnvQicRrg",
  videoTestimonial: "https://www.youtube.com/embed/9-XVqNfMHZQ",
  videoPreviewImage: DataSciencePreview,

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `The Data Analytics Bootcamp of the Data School is
        designed to help professionals learn analytics and data strategy,
        bringing the value of Big Data Analytics to your current role.`,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
